module.exports = __webpack_public_path__ + "img/67.c33af53b.jpg";